package pl.decks.personal.components.widgets.ranks.shapes

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.dom.svg.Line
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.toAttrs
import pl.decks.personal.components.widgets.ranks.SVGPoint
import pl.decks.personal.components.widgets.ranks.x
import pl.decks.personal.components.widgets.ranks.y

@Composable
fun RankLine(
    color: Color = Colors.White,
    modifier: Modifier = Modifier,
) {
    val width = 100f
    val height = 1f
    val middle = height / 2
    val startPoint: SVGPoint = 0f to middle
    val endPoint: SVGPoint = width to middle

    Box(modifier) {
        Svg(
            attrs = Modifier
                .fillMaxSize()
                .overflow(Overflow.Visible)
                .toAttrs {
                    attr("viewBox", "0 0 $width $height")
                    attr("preserveAspectRatio", "none")
                }
        ) {
            Line {
                attr("x1", startPoint.x.toString())
                attr("y1", startPoint.y.toString())
                attr("x2", endPoint.x.toString())
                attr("y2", endPoint.y.toString())
                attr("stroke", color.toString())
                attr("stroke-width", 1f.toString())
                attr("stroke-linecap", "round")
            }
        }
    }
}
